var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageDocument)?_c('div',{staticClass:"page"},[(_vm.pageDocument.blocks)?_c('blocks',{attrs:{"blocks":_vm.pageDocument.blocks,"origin":_vm.ORIGIN.PAGE,"is-on-top-of-page":""}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }